import "./SectionTitle.css";

const SectionTitle = ({ title}) => {
  return (
    <div className="section-title">
      <span className="section-title-line" />
      <p className="section-title-text">{title}</p>
    </div>
  );
};

export default SectionTitle;